module.exports = __webpack_public_path__ + "static/media/saxophone_lessions.a5feb570.jpeg";